
import { AppService } from "app/services/app.service";
import { Endereco } from "app/models/endereco";
import { Observable } from "rxjs";

export abstract class AbEnderecoContato extends AppService {
  abstract getEnderecoCompleto(cep: number): Observable<any>;
  abstract getEnderecoTipoEndereco(tipoEndereco: String): Observable<any>;
  abstract getEnderecoTipoEnderecoByPessoaId(tipoEndereco: String, pessoaId: number, isSigma: boolean): Observable<any>;
  abstract getEnderecoConta(idConta: number): Observable<any>;
  abstract salvarAdmin(endereco: Endereco): Observable<any>;
  abstract salvar(endereco: Endereco): Observable<any>;
  abstract getPaises(): Observable<any>;
  abstract obrigatoriedadeCampo(obrigatorio, campo): Boolean;
}
